/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCheckRealized = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 5h20v8.5h-2V7H4v10h9v2H2V5zm16 6H6V9h12v2zm-5 4H6v-2h7v2zm9.707 1.707L18 21.414l-2.707-2.707 1.414-1.414L18 18.586l3.293-3.293 1.414 1.414z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCheckRealized as CheckRealized };
